import React from 'react'
import {Link, useNavigate} from "react-router-dom";
import Sidebar from "../../../../../components/Sidebar";
import PageHeader from "../../../../../components/PageHeader";
import {toast} from "react-toastify";
import DatePicker, {registerLocale} from "react-datepicker";
import {getSchoolYear} from "../../../../../utils/authority";
import ClassRoomController from "../../../../../services/data-declaration/class-room-controller";
import StudentController from "../../../../../services/system/student/student-controller";
import vi from "date-fns/locale/vi";
registerLocale("vi", vi);
function withRouter(Component) {
    return (props) => <Component {...props} navigate={useNavigate()} />;
}
class CreateFeesManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            "autoGenCode": true,
            "bietBoi": false,
            "birthday": null,
            "birthdayFather": null,
            "birthdayGiamHo": null,
            "birthdayMother": null,
            "cheDoChinhSach": "CHE_DO_CHINH_SACH_1",
            "cheDoHoTro": "CHE_DO_HO_TRO_1",
            "choO": "TRONG_TRUONG",
            "code": "",
            "currentClassRoomId": 0,
            "dangDay": null,
            "dangVien": false,
            "dienHocSinh": "DIEN_HOC_SINH_1",

            "doanDay": null,
            "doanVien": false,
            "doiDay": null,
            "doiTuongUuTien": "UU_TIEN_1",
            "doiVien": false,
            "email": "",
            "ethnic": "KINH",
            "fatherDanToc": false,
            "fullName": "",
            "fullNameFather": "",
            "fullNameGiamHo": "",
            "fullNameMother": "",
            "gender": "MALE",
            "gradeId": "",
            "heHocNN": "TIENG_ANH",
            "hinhThuc": "TRUNG_TUYEN",
            "identify": "",
            "ishocTruongTrinhGDBo": true,
            "iskhuyetTat": false,
            "jobFather": "",
            "jobGiamHo": "",
            "jobMother": "",
            "khuyetTat": "KHUYET_TAT_1",
            "mailFather": "",
            "mailGiamHo": "",
            "mailMother": "",
            "motherDanToc": false,
            "nhomMau": "NHOM_MAU_1",
            "noiSinh": "",
            "phone": "",
            "phoneFather": "",
            "phoneGiamHo": "",
            "phoneHome": "",
            "phoneMother": "",
            "pointDegree": "TRUNG_BINH",
            "queQuan": "",
            "religion": "NO",
            "schoolDay":null,
            "sodangbo": "",
            "state": "CHUA_PHANLOP",
            "taiDinhCu": false,
            "tamTru": "",
            "tengoiEthnnic": "",
            "thanhPhanParent": "THANH_PHAN_PARENT_1",
            "thuongTru": "",
            "address": "",
            "wardCode": "",
            "provinceCode": "",
            "districtCode": "",
            yearId: parseInt(getSchoolYear()),
            "zone": "",
            listClassRoom: [],
        };
    }

    componentWillMount() {
        this.getListClassRoom()
    }

    getListClassRoom = () => {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            "sort": "created_at desc"
        };
        ClassRoomController.list(payload, res => {
            this.setState({
                showLoading: false,
                listClassRoom: res.data.content,
                totalItem: res.data.totalElements,
                totalPage: Math.round(res.data.totalElements / this.state.pageSize)
            });
        })
    };
    renderClassRoom = () => {
        return this.state.listClassRoom.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    };
    onCreate = () => {
        let {fullName} = this.state;
        if (fullName == "" || fullName.length < 5){
            toast.error("Tên học sinh phải lớn hơn 6 ký tự");
        }else if(this.state.gradeId == ""){
            toast.error("Vui lòng chọn khối học");
        }else if(this.state.address == "" || this.state.wardId == undefined || this.state.provinceId==undefined || this.state.districtId == undefined){
            toast.error("Vui lòng nhập địa chỉ học sinh");
        }else if (!(this.state.fullNameFather !== "" && this.state.birthdayFather !== "" && this.state.jobFather !== ""  && this.state.phoneFather !== ""  && this.state.mailFather !== "") &&
            !(this.state.fullNameMother !== "" && this.state.birthdayMother !== "" && this.state.jobMother !== ""  && this.state.phoneMother !== ""  && this.state.mailMother !== "") &&
            !(this.state.fullNameGiamHo !== "" && this.state.birthdayGiamHo !== "" && this.state.jobGiamHo !== ""  && this.state.phoneGiamHo !== ""  && this.state.mailGiamHo !== "")
        ) {
            toast.error("Vui lòng nhập đủ thông tin của ít nhất 1 người(Bố hoặc mẹ hoặc người giám hộ");
        }else {
            let payload = {
                "autoGenCode": this.state.autoGenCode,
                "bietBoi": this.state.bietBoi,
                "birthday": this.state.birthday,
                "birthdayFather": this.state.birthdayFather,
                "birthdayGiamHo": this.state.birthdayGiamHo,
                "birthdayMother": this.state.birthdayMother,
                "cheDoChinhSach": this.state.cheDoChinhSach,
                "cheDoHoTro": this.state.cheDoHoTro,
                "choO": this.state.choO,
                "code": this.state.code,
                "currentClassRoomId": parseInt(this.state.currentClassRoomId),
                "dangDay": this.state.dangDay,
                "dangVien":  this.state.dangVien,
                "dienHocSinh": this.state.dienHocSinh,
                "districtCode": this.state.districtId,
                "doanDay": this.state.doanDay,
                "doanVien": this.state.doanVien,
                "doiDay": this.state.doiDay,
                "doiTuongUuTien": this.state.doiTuongUuTien,
                "doiVien": this.state.doiVien,
                "email": this.state.email,
                "ethnic": this.state.ethnic,
                "fatherDanToc":  this.state.fatherDanToc,
                "fullName": this.state.fullName,
                "fullNameFather":this.state.fullNameFather,
                "fullNameGiamHo": this.state.fullNameGiamHo,
                "fullNameMother": this.state.fullNameMother,
                "gender": this.state.gender,
                "grade": this.state.gradeId,
                "heHocNN": this.state.heHocNN,
                "hinhThuc": this.state.hinhThuc,
                "identify": this.state.identify,
                "ishocTruongTrinhGDBo": this.state.ishocTruongTrinhGDBo,
                "iskhuyetTat": this.state.iskhuyetTat,
                "jobFather": this.state.jobFather,
                "jobGiamHo": this.state.jobGiamHo,
                "jobMother": this.state.jobMother,
                "khuyetTat": this.state.khuyetTat,
                "mailFather": this.state.mailFather,
                "mailGiamHo": this.state.mailGiamHo,
                "mailMother": this.state.mailMother,
                "motherDanToc": this.state.motherDanToc,
                "nhomMau": this.state.nhomMau,
                "noiSinh": this.state.noiSinh,
                "phone": this.state.phone,
                "phoneFather": this.state.phoneFather,
                "phoneGiamHo": this.state.phoneGiamHo,
                "phoneHome": this.state.phoneHome,
                "phoneMother":this.state.phoneMother,
                "pointDegree": this.state.pointDegree,
                "provinceCode": this.state.provinceId,
                "queQuan": this.state.queQuan,
                "religion": this.state.religion,
                "schoolDay": this.state.schoolDay,
                "sodangbo": this.state.sodangbo,
                "state": this.state.state,
                "taiDinhCu": this.state.taiDinhCu,
                "tamTru": this.state.address,
                "tengoiEthnnic": this.state.tengoiEthnnic,
                "thanhPhanParent": this.state.thanhPhanParent,
                "thuongTru": this.state.thuongTru,
                "wardCode": this.state.wardId,
                "yearId": parseInt(getSchoolYear()),
                "zone": this.state.zone
            }
            StudentController.create(payload, res => {
                if (res.success){
                    this.props.navigate('/ad-sas-school/quan-ly-thong-tin-hoc-sinh');
                    toast.success("Tạo học sinh thành công!")
                } else {
                    toast.error("Đã xảy ra lỗi! " + res.message)
                }
            })
        }
    }
    onUpdateGrade(gradeId){
        this.setState({
            gradeId: gradeId
        })
    }
    render() {
        let {gradeId, address, wardId, districtId, provinceId} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="stand-fees" parentClass="wallet-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            <div className="card col-12">
                                <div className='pt-3 mb-2'>
                                    <PageHeader routerEnable={true} title="Quản lý các loại phí"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <h2 className='text-center mb-4'>THÊM MỚI LOẠI PHÍ</h2>
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tên loại phí(<span  style={{color: "red",}}>*</span>)</label>
                                                <input
                                                    placeholder="Nhập tên loại phí"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.fullName}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            fullName: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Đơn vị tính</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.gender}
                                                    onChange={(e) => {
                                                        this.state.gender = e.target.value;
                                                        this.setState({
                                                            gender: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="MALE">Lần</option>
                                                    <option value="FEMALE">Chiếc</option>
                                                    <option value="OTHER">Bộ</option>
                                                    <option value="OTHER">Lốc</option>
                                                    <option value="OTHER">Tháng</option>
                                                    <option value="OTHER">Quý</option>
                                                    <option value="OTHER">Kỳ</option>
                                                    <option value="OTHER">Năm</option>
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Số tiền</label>
                                                <input
                                                    placeholder="Nhập số tiền"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.sodangbo}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            sodangbo: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>

                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Ghi chú</label>
                                                <input
                                                    placeholder="Nhập nơi sinh ra"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.noiSinh}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            noiSinh: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Trạng thái</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.gender}
                                                    onChange={(e) => {
                                                        this.state.gender = e.target.value;
                                                        this.setState({
                                                            gender: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="MALE">Kích hoạt</option>
                                                    <option value="FEMALE">Khóa</option>
                                                </select>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="align-right col-12">
                                    <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s background-btn type-button-fix btn btn-primary shadow-none"
                                            disabled={this.state.fullName == ""}
                                            onClick={()=> {
                                                this.onCreate()
                                            }}
                                        >
                                            Lưu
                                        </button>
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s type-button-fix btn btn-light shadow-none"
                                        >
                                            <Link
                                                style={{color: '#000'}}
                                                to={{
                                                    pathname: "/ad-sas-school/cac-khoan-phi-tieu-chuan"
                                                }}
                                            >
                                                Hủy bỏ
                                            </Link>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(CreateFeesManagement)
